// extracted by css-extract-rspack-plugin
export default {"desktop-buttons-wrapper":"RefundModal-module__desktop-buttons-wrapper--V3hxg","desktopButtonsWrapper":"RefundModal-module__desktop-buttons-wrapper--V3hxg"};